/** Copy de baja bloqueada (409 `tiene_historial`). Mismo texto en API y toast. */

export const MSG_ELIMINAR_CON_MOVIMIENTOS =
  "No se puede eliminar porque tiene movimientos relacionados.";

function errorCode(error: unknown): string {
  if (error == null || typeof error !== "object") return "";
  const e = error as {
    code?: unknown;
    error?: unknown;
    data?: { error?: unknown };
  };
  if (typeof e.code === "string" && e.code.trim()) return e.code;
  if (typeof e.error === "string" && e.error.trim()) return e.error;
  if (typeof e.data?.error === "string" && e.data.error.trim()) return e.data.error;
  return "";
}

function errorMessage(error: unknown): string {
  if (error == null || typeof error !== "object") return "";
  const msg = (error as { message?: unknown }).message;
  return typeof msg === "string" ? msg.trim() : "";
}

/**
 * Toast / API clients: humano, sin “409”. CF conserva el mensaje de backend.
 */
export function mensajeBajaBloqueada(
  error: unknown,
  fallback = "Error al eliminar",
): string {
  const msg = errorMessage(error);
  if (msg.toLowerCase().includes("consumidor final")) return msg;
  if (errorCode(error) === "tiene_historial") return MSG_ELIMINAR_CON_MOVIMIENTOS;
  return msg || fallback;
}
